export default "__VITE_ASSET__BNO8VOT9__"